const TENANT_SUBDOMAIN_REGEX = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;
const EKO_LABEL_REGEX = /^eko(?:-[a-z0-9-]+)?$/;

const parseTenantHost = (hostname = "") => {
  if (!hostname || typeof hostname !== "string") {
    return { isEkoSubdomain: false, tenant: null };
  }

  const normalizedHost = hostname.trim().toLowerCase().replace(/\.$/, "");
  const labels = normalizedHost.split(".").filter(Boolean);

  // Expected pattern: tenant.eko[...].domain
  if (labels.length < 3) {
    return { isEkoSubdomain: false, tenant: null };
  }

  const [candidateTenant, systemLabel] = labels;
  const isEkoSubdomain = EKO_LABEL_REGEX.test(systemLabel);

  if (!isEkoSubdomain) {
    return { isEkoSubdomain: false, tenant: null };
  }

  if (!TENANT_SUBDOMAIN_REGEX.test(candidateTenant)) {
    return { isEkoSubdomain: true, tenant: null };
  }

  return { isEkoSubdomain: true, tenant: candidateTenant };
};

export const getTenantCandidateFromHostname = (hostname = "") => {
  if (!hostname || typeof hostname !== "string") {
    return "";
  }

  const normalizedHost = hostname.trim().toLowerCase().replace(/\.$/, "");
  const labels = normalizedHost.split(".").filter(Boolean);
  return labels[0] || "";
};

export const getTenantFromHostname = (hostname = "") => {
  return parseTenantHost(hostname).tenant;
};

export const isEkoSubdomainRequest = (hostname = "") => {
  return parseTenantHost(hostname).isEkoSubdomain;
};

export const getLoginPathForTenantContext = ({ slug = "", hostname = "" } = {}) => {
  const resolvedHostname =
    hostname ||
    (typeof window !== "undefined" && window.location ? window.location.hostname : "");

  void slug;

  if (isEkoSubdomainRequest(resolvedHostname)) {
    return "/login";
  }

  return "/login";
};

export const buildTenantLoginUrl = ({ slug = "", search = "" } = {}) => {
  const trimmedSlug = typeof slug === "string" ? slug.trim().toLowerCase() : "";
  const normalizedSearch =
    typeof search === "string" && search.length > 0
      ? search.startsWith("?")
        ? search
        : `?${search}`
      : "";

  if (!trimmedSlug) {
    return `/login${normalizedSearch}`;
  }

  if (typeof window === "undefined" || !window.location) {
    return `/login${normalizedSearch}`;
  }

  const { hostname = "", protocol = "https:", port = "" } = window.location;
  const labels = hostname.trim().toLowerCase().replace(/\.$/, "").split(".").filter(Boolean);
  const systemLabel = labels[0] || "";
  const isBaseEkoHost = EKO_LABEL_REGEX.test(systemLabel);

  if (isBaseEkoHost) {
    const tenantHostname = `${trimmedSlug}.${hostname}`;
    const hostWithPort = port ? `${tenantHostname}:${port}` : tenantHostname;
    return `${protocol}//${hostWithPort}/login${normalizedSearch}`;
  }

  if (isEkoSubdomainRequest(hostname)) {
    return `/login${normalizedSearch}`;
  }

  // Local dev fallback:
  // localhost:3000 -> tenant.eko-devlocalhost:3000/login
  if (hostname === "localhost") {
    const tenantHostname = `${trimmedSlug}.eko-dev.localhost`;
    const hostWithPort = port ? `${tenantHostname}:${port}` : tenantHostname;
    return `${protocol}//${hostWithPort}/login${normalizedSearch}`;
  }

  return `/login${normalizedSearch}`;
};
